/* eslint-disable */
import {Base64} from 'js-base64';

export function hashObject(object: any): string {
  return Base64.encode(JSON.stringify(object || {}), true); // TODO improve
}
